// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3J1Rg","title":"Header_title__pNyKR","side":"Header_side__1vePT"};